export let appGroups = "xTBF6d";
export default {appGroups};